// store.js
import { createStore } from 'vuex'
export const store = createStore({
    state () {
        return {
            smallHeader: false,
            filterOpen: false,
            filterDepartmentOpen: false,
            popupOpen: false,
            popupObject: {},
            triggerTransitionOverlay: Math.random(),
            routerNext: null,
            mobileNavOpen: false,
            didInitialSiteTransition: false,
            searchTerm: '',
            deepFilterLink: null,
            selectedFilters: [],
            selectedDepartmentFilters: [{ label: "All Departments", slug: "all" }],
            searchResults: null,  // null is not searched, [] is result set
            searchLoading: false, // property to track search loading state
            searchError: false, // property to track search error state
            careersJson: null,
        }
    },
    mutations: {
        setCareersJson (state, obj) {
            state.careersJson = obj
        },
        setSmallHeader (state, val) {
            state.smallHeader = val
        },
        openPopup (state, obj) {
            state.popupObject = obj
            state.popupOpen = true
        },
        closePopup (state) {
            state.popupObject = {}
            state.popupOpen = false
        },
        openFilter (state) {
            state.filterOpen = true
        },
        closeFilter (state) {
            state.filterOpen = false
        },
        openDepartmentFilter (state) {
            state.filterDepartmentOpen = true
        },
        closeDepartmentFilter (state) {
            state.filterDepartmentOpen = false
        },
        triggerTransitionOverlay (state) {
            state.triggerTransitionOverlay = Math.random()
        },
        routerNext(state, next) {
            state.routerNext = next
        },
        setMobileNavOpen(state, val) {
            state.mobileNavOpen = val
        },
        setDidInitialSiteTransition(state) {
            state.didInitialSiteTransition = true
        },
        setSearchTerm(state, val) {
            state.searchTerm = val
        },
        setDeepFilterLink(state, val) {
            state.deepFilterLink = val
        },
        filterClick(state, item) {
            if (item.slug === "all") {
                const index = state.selectedFilters.findIndex(filter => filter.slug === 'all');
                if (index === -1) {
                    // When clicking "All", clear any other filters and add "all"
                    state.selectedFilters = [{ ...item }];
                } else {
                    // Remove "All" if it's already selected
                    state.selectedFilters.splice(index, 1);
                }
            } else {
                // Remove the "all" filter if present when selecting another filter
                const allIndex = state.selectedFilters.findIndex(filter => filter.slug === 'all');
                if (allIndex !== -1) {
                    state.selectedFilters.splice(allIndex, 1);
                }
                const index = state.selectedFilters.findIndex(filter => filter.slug === item.slug);
                if (index === -1) {
                    // Add the filter if not already selected
                    state.selectedFilters.push(item);
                } else {
                    // Remove the filter if already selected
                    state.selectedFilters.splice(index, 1);
                }
            }
        },
        filterDepartmentClick(state, item) {
            if (item.slug === "all") {
                const index = state.selectedDepartmentFilters.findIndex(filter => filter.slug === 'all');
                if (index === -1) {
                    // When clicking "All", clear any other filters and add "all"
                    state.selectedDepartmentFilters = [{ ...item }];
                } else {
                    // Remove "All" if it's already selected
                    state.selectedDepartmentFilters.splice(index, 1);
                    // If no filters remain, add "All" back
                    if (state.selectedDepartmentFilters.length === 0) {
                        state.selectedDepartmentFilters = [{ label: "All Departments", slug: "all" }];
                    }
                }
            } else {
                // Remove the "all" filter if present when selecting another filter
                const allIndex = state.selectedDepartmentFilters.findIndex(filter => filter.slug === 'all');
                if (allIndex !== -1) {
                    state.selectedDepartmentFilters.splice(allIndex, 1);
                }
                const index = state.selectedDepartmentFilters.findIndex(filter => filter.slug === item.slug);
                if (index === -1) {
                    // Add the filter if not already selected
                    state.selectedDepartmentFilters.push(item);
                } else {
                    // Remove the filter if already selected
                    state.selectedDepartmentFilters.splice(index, 1);
                }
                // Ensure the filters are never empty
                if (state.selectedDepartmentFilters.length === 0) {
                    state.selectedDepartmentFilters = [{ label: "All Departments", slug: "all" }];
                }
            }
        },
        // Mutation to set search results
        setSearchResults(state, results) {
            state.searchResults = results;
        },
        // Mutation to clear or set selected filters
        setSelectedFilters(state, filters) {
            state.selectedFilters = filters;
        },
        // Mutation to clear or set selected filters
        setSelectedDepartmentFilters(state, filters) {
            state.selectedDepartmentFilters = filters;
        },
        // New mutation to set the search loading flag
        setSearchLoading(state, flag) {
            state.searchLoading = flag;
        },
        // New mutation to set the search error flag
        setSearchError(state, flag) {
            state.searchError = flag;
        }
    }
})
export default store
